"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeSchema = exports.Field = exports.resolve = exports.schemaComponents = void 0;
const core_1 = require("react-hook-schema/core");
const standard_1 = require("react-hook-schema/standard");
const localSchemaComponents = __importStar(require("./modules"));
exports.schemaComponents = Object.assign(Object.assign({}, standard_1.standardSchemaComponents), localSchemaComponents);
exports.resolve = (0, core_1.createResolver)(exports.schemaComponents);
exports.Field = (0, core_1.createSelector)(exports.schemaComponents);
exports.mergeSchema = core_1.mergeSchema;
